export { CashIcon } from './cash'
